import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SuccessModel } from "./success.model";

@Component({
  selector: "ngx-success-order",
  templateUrl: "./success-order.component.html",
  styleUrls: ["./success-order.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuccessOrderComponent extends BaseFormComponent<any> {
  public model: any;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  async ngOnInit(): Promise<void> {
    this.FillData();
  }

  FillData(): void {
    this.columns = [];
    const newGroup: any = {};
    this.formGroup = new UntypedFormGroup(newGroup);
    this.setValue("CookingTime", this.model?.CookingDuration ?? "0");
    this.setValue("SendingTime", this.model?.DeliveryDuration ?? "0");
  }

  onCookingTimeChange(value: number): void {
    if (Number(value) > 60) this.formGroup.controls["CookingTime"].setValue(60);
  }

  public async save(): Promise<void> {
    const successModel = new SuccessModel();
    successModel.CookingTime = this.formGroup.controls["CookingTime"].value;
    successModel.SendingTime = this.formGroup.controls["SendingTime"].value;
    this.result = successModel;
    this.close();
  }
}
